module.exports = __webpack_public_path__ + "media/form-type-page/project-diagram-91f6dbcb.svg";